<template>
  <footer class="footer section-card">
    <div class="footer-top">
      <div class="footer-brand">
        <a href="#home" class="logo" @click.prevent="scrollToSection('home')">
          <span class="logo-soon">SOON</span><span class="logo-forward">FORWARD</span>
        </a>
        <div class="footer-social">
          <a
            v-for="social in socialLinks"
            :key="social.icon"
            :href="social.href"
            :aria-label="`${social.label} (opens in a new tab)`"
            class="icon-badge footer-social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <component :is="social.icon" aria-hidden="true" />
          </a>
        </div>
      </div>

      <div class="footer-links">
        <div
          v-for="(col, index) in footerColumns"
          :key="col.title"
          class="footer-col"
          role="group"
          :aria-labelledby="`footer-col-heading-${index}`"
        >
          <p :id="`footer-col-heading-${index}`" class="title title-sm">{{ col.title }}</p>
          <a v-for="link in col.links" :key="link.label" :href="link.href"
          class="footer-link text-muted">
            {{ link.label }}
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <span class="footer-separator"></span>
      <p class="footer-copyright">
        Copyright © {{ currentYear }} SoonForward. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script>
import '../assets/styles/landing-shared.scss';
import scrollToSectionUtil from '../utils/scrollToSection';

export default {
  name: 'Landing2Footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      socialLinks: [
        {
          icon: 'b-icon-facebook',
          href: 'https://www.facebook.com/people/SoonForward/100085242398681',
          label: 'Facebook',
        },
        {
          icon: 'b-icon-instagram',
          href: 'https://instagram.com/soonforwardco',
          label: 'Instagram',
        },
        {
          icon: 'b-icon-whatsapp',
          href: 'https://wa.me/13474601773',
          label: 'WhatsApp',
        },
      ],
      footerColumns: [
        {
          title: 'Resources',
          links: [{ label: 'Help & Support', href: '#' }],
        },
        {
          title: 'Legal',
          links: [
            { label: 'Terms Of Service', href: '#' },
            { label: 'Privacy Policy', href: '#' },
          ],
        },
      ],
    };
  },
  methods: {
    scrollToSection: scrollToSectionUtil,
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/fluid';

.footer {
  display: flex;
  flex-direction: column;
  height: 20rem;
  padding: 4rem 4rem 2rem;
  border-radius: 2rem 2rem 0 0;
}

.footer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.footer-social {
  display: flex;
  gap: 1rem;
}

.footer-social-icon {
  width: 2rem;
  height: 2rem;
  background: var(--color-card-bg);
}

.footer-social-icon svg {
  width: 1rem;
  height: 1rem;
}

.footer-links {
  display: flex;
  align-items: flex-start;
  gap: 4rem;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-link {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.1875rem;
  color: var(--color-text-secondary);
  text-decoration: none;
}

.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin-top: auto;
}

.footer-separator {
  width: 100%;
  height: 2px;
  background: rgba(23, 23, 23, 0.07);
}

.footer-copyright {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 0.9375rem;
  color: var(--color-text-muted);
}

@media (max-width: 767px) {
  .footer {
    height: auto;
    padding: 3rem 1.375rem 2rem;
    border-radius: 0;
  }

  .footer-top {
    flex-direction: column;
    align-items: center;
    gap: 2.5rem;
  }

  .footer-brand {
    align-items: center;
  }

  .footer-links {
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 2rem;
  }

  .footer-col {
    flex: 1 1 40%;
    align-items: center;
    text-align: center;
  }

  .footer-bottom {
    margin-top: 3rem;
  }
}

@media (min-width: 768px) and (max-width: 1439px) {
  .footer {
    height: auto;
    padding: fluid(3rem, 4rem) fluid(1.375rem, 4rem) 2rem;
    border-radius: 0;
  }

  .footer-top {
    flex-direction: column;
    align-items: center;
    gap: 2.5rem;
  }

  .footer-brand {
    align-items: center;
  }

  .footer-links {
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: fluid(2rem, 4rem);
  }

  .footer-col {
    flex: 1 1 40%;
    align-items: center;
    text-align: center;
  }

  .footer-bottom {
    margin-top: 3rem;
  }
}
</style>
